var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgSubmittedIconMod = function SvgSubmittedIconMod(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82.001,
    height: 82.001
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5648"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 126",
    d: "M41 82a40.735 40.735 0 01-15.959-3.222 40.863 40.863 0 01-13.032-8.788 40.858 40.858 0 01-8.787-13.032A40.744 40.744 0 010 41a40.751 40.751 0 013.222-15.959 40.879 40.879 0 018.787-13.032 40.859 40.859 0 0113.032-8.787A40.735 40.735 0 0141 0a40.735 40.735 0 0115.959 3.222 40.845 40.845 0 0113.033 8.787 40.879 40.879 0 018.787 13.032A40.751 40.751 0 0182 41a40.744 40.744 0 01-3.222 15.958 40.858 40.858 0 01-8.787 13.032 40.868 40.868 0 01-13.033 8.788A40.735 40.735 0 0141 82zm0-78a36.779 36.779 0 00-14.4 2.908 36.884 36.884 0 00-11.761 7.929 36.9 36.9 0 00-7.93 11.761A36.788 36.788 0 004 41a36.788 36.788 0 002.907 14.4 36.906 36.906 0 007.93 11.761 36.875 36.875 0 0011.761 7.929A36.769 36.769 0 0041 78a36.78 36.78 0 0014.4-2.908 36.868 36.868 0 0011.76-7.929 36.882 36.882 0 007.931-11.761A36.788 36.788 0 0078 41a36.788 36.788 0 00-2.907-14.4 36.871 36.871 0 00-7.931-11.761 36.874 36.874 0 00-11.76-7.929A36.788 36.788 0 0041 4z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon feather-check",
    d: "M59.545 28.251l-25.499 25.5-11.59-11.592",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }))));
};
export default SvgSubmittedIconMod;